<template>
  <div>
    <h1 class="mb-4" v-if="!fund.precheck">
      {{ $t("fund.report.minimalRequirements.title") }}
    </h1>

    <v-card>
      <template v-for="(category, index) in categories">
        <v-card-title :key="`${index}-title`">
          {{ $t(`minimalRequirementCategory.${index}.name`) }}
        </v-card-title>

        <v-simple-table class="v-align-top table-no-hover" :key="`${index}-table`">
          <template #default>
            <tbody>
              <tr v-for="requirement in category" :key="requirement.id">
                <td width="50%">
                  <strong>
                    {{ $t(`minimalRequirement.${requirement.requirementId}.name`) }}
                  </strong>

                  <Markdown :value="$t(`minimalRequirement.${requirement.requirementId}.description`)" />
                </td>

                <td>
                  <Markdown :value="requirement.result.description" />

                  <div
                    v-if="
                      type === 'provisional' &&
                        fund.mayGiveFeedback &&
                        !audit &&
                        !audituser &&
                        !requirement.auditorFeedback
                    "
                    class="mt-4"
                  >
                    <MinimalRequirementUserFeedbackForm :requirement="requirement" />
                  </div>
                </td>

                <td v-if="audit">
                  <Markdown :value="requirement.result.applicable ? requirement.result.result : 'NA'" />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </template>
    </v-card>
  </div>
</template>

<script>
import groupByCategory from "@/utils/Requirements/groupByCategory";
import MinimalRequirementUserFeedbackForm from "./MinimalRequirementUserFeedbackForm";

export default {
  components: {
    MinimalRequirementUserFeedbackForm,
  },

  props: {
    fund: {
      type: Object,
      required: true,
    },

    requirements: {
      type: Array,
      required: true,
    },

    audit: {
      type: Boolean,
      default: false,
    },

    audituser: {
      type: Boolean,
      default: false,
    },

    type: {
      type: String,
      default: "final",
    },
  },

  computed: {
    categories() {
      return groupByCategory(this.requirements);
    },
  },
};
</script>
